﻿import { defineStore } from 'pinia'
import type { EventDto } from '@/types'
import { ref } from 'vue'
import { getEventById } from '@/api'

export const useEventStore = defineStore('event', function () {
    const event = ref<EventDto | null>(null)
    async function getEvent(id: number) {
        event.value = await getEventById(id)
    }
    return { event, getEvent }
})
